export const createDateUtils = () => {
    // Caché para fechas normalizadas
    const normalizedDatesCache = new Map();
    
    return {
      normalizeDate: (dateString) => {
        if (normalizedDatesCache.has(dateString)) {
          return normalizedDatesCache.get(dateString);
        }
        
        const date = new Date(dateString);
        const normalized = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        normalizedDatesCache.set(dateString, normalized);
        return normalized;
      },
      
      // Otras funciones útiles
      isToday: (dateString) => {
        const today = new Date();
        const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        return dateString === todayString;
      },
      
      isWithinDays: (dateString, days) => {
        const date = new Date(dateString);
        const compareDate = new Date();
        compareDate.setDate(compareDate.getDate() - days);
        return date >= compareDate;
      }
    };
  };
  
  // Exportación de un singleton para uso global
  export const dateUtils = createDateUtils();